import { WprLogLevel, WprErrorInfo } from './WprErrorInfo';
import { WprBaseMngr } from '../WprBaseMngr';
import { WprSettingInfo } from '../WprSettingInfo';
import { WprBaseFrameworkComponent } from '../component/base/WprBaseFrameworkComponent';

/**
 * エラー管理機能
 */
export class WprErrorMngr extends WprBaseMngr {
	// private 変数  ------------------------------------------------------------
	private ERROR_INFO_MAX 				= 1000;					// 最大エラー数
	private m_LogLevel: WprLogLevel		= WprLogLevel.WARNING;	// 出力ログレベル
	private m_ErrorList: WprErrorInfo[]	= new Array();			// エラー情報リスト
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('エラー管理機能');
	}
	// --------------------------------------------------------------------------

	// override メソッド	-----------------------------------------------------
	/**
	 * 初期化処理
	 * @param loader データローダ
	 * @param setting 設定情報
	 */
	public initialize(loader: WprBaseFrameworkComponent, setting: WprSettingInfo): void {
		this.m_LogLevel = setting.logLevel;
	}
	// --------------------------------------------------------------------------

	// public メソッド	---------------------------------------------------------
	/**
	 * 通常ログ出力
	 * @param clsName クラス名
	 * @param msg メッセージ
	 */
	public addDebugLog(clsName: string, msg: string): void {
		if (this.m_LogLevel <= WprLogLevel.DEBUG)
			this.addLog(WprLogLevel.DEBUG, clsName, msg);
	}

	/**
	 * 情報ログ出力
	 * @param clsName クラス名
	 * @param msg メッセージ
	 */
	public addInfoLog(clsName: string, msg: string): void {
		if (this.m_LogLevel <= WprLogLevel.INFO)
			this.addLog(WprLogLevel.INFO, clsName, msg);
	}

	/**
	 * 警告ログ出力
	 * @param clsName クラス名
	 * @param msg メッセージ
	 */
	public addWarningLog(clsName: string, msg: string): void {
		if (this.m_LogLevel <= WprLogLevel.WARNING)
			this.addLog(WprLogLevel.WARNING, clsName, msg);
	}

	/**
	 * エラーログ出力
	 * @param clsName クラス名
	 * @param msg メッセージ
	 * @param ex 例外情報
	 */
	public addErrorLog(clsName: string, msg: string, ex?: Error): void {
		if (ex === undefined)
			this.addLog(WprLogLevel.ERROR, clsName, msg);
		else
			this.addLog(WprLogLevel.EXCEPTION, clsName, msg, ex);
	}
	// --------------------------------------------------------------------------

	// private メソッド	---------------------------------------------------------
	/**
	 * ログ追加処理
	 * @param level ログレベル
	 * @param clsName クラス名
	 * @param msg メッセージ
	 * @param ex 例外情報
	 */
	private addLog(level: WprLogLevel, clsName: string, msg: string, ex?: Error): void {
		const errInfo = new WprErrorInfo(level, clsName, msg, ex);
		if (level !== WprLogLevel.INFO) {
			if (this.m_ErrorList.length >= this.ERROR_INFO_MAX) {
				this.m_ErrorList.pop();
				this.m_ErrorList.unshift(errInfo);
			}
		}
		// ATODE ローカルストレージ対応
		const log = errInfo.getLogMessage();
		this.writerLog(log);
		if (ex !== undefined) {
			// this.writerLog('    ' + ex.message);
			this.writerLog('    ' + ex.stack);
		}
	}

	/**
	 * ログ出力処理
	 * @msg ログメッセージ
	 */
	private writerLog(msg: string): void {
		console.log(msg);
	}
	// --------------------------------------------------------------------------
}
